export const contactText = {
  JP: {
    subTitle: 'CONTACT',
    title: 'ご予約・お問い合わせ',
    description:
      'ご予約やご質問はInstagramまたは公式LINEよりお気軽にお問い合わせください。',
    info: {
      hours: {
        title: '受付時間',
        lines: ['いつでも可', '（年中無休）'],
      },
      reply: {
        title: 'ご返信について',
        lines: ['なるべく早くご返信いたします。'],
      },
      consultation: {
        title: 'お気軽にご相談ください',
        lines: ['ご希望やご質問など、', 'なんでもご相談ください。'],
      },
    },
    buttons: {
      instagram: {
        title: 'Instagram',
        text: 'DMで相談、予約する',
      },
      line: {
        title: '公式LINE',
        text: '相談、予約する',
      },
    },
  },

  EN: {
    subTitle: 'CONTACT',
    title: 'Bookings & Inquiries',
    description:
      'For bookings or questions, feel free to contact us through Instagram or our official LINE.',
    info: {
      hours: {
        title: 'Available Hours',
        lines: ['Anytime', 'Open all year round'],
      },
      reply: {
        title: 'About Replies',
        lines: ['We will reply as soon as possible.'],
      },
      consultation: {
        title: 'Feel Free to Ask',
        lines: ['Tell us your requests or questions.', 'We are happy to help.'],
      },
    },
    buttons: {
      instagram: {
        title: 'Instagram',
        text: 'Ask or book by DM',
      },
      line: {
        title: 'Official LINE',
        text: 'Ask or book here',
      },
    },
  },

  中文: {
    subTitle: 'CONTACT',
    title: '预约・咨询',
    description:
      '如需预约或咨询，欢迎通过 Instagram 或官方 LINE 与我们联系。',
    info: {
      hours: {
        title: '受理时间',
        lines: ['随时可以联系', '全年无休'],
      },
      reply: {
        title: '关于回复',
        lines: ['我们会尽快回复。'],
      },
      consultation: {
        title: '欢迎随时咨询',
        lines: ['无论是需求还是问题，', '都欢迎随时咨询。'],
      },
    },
    buttons: {
      instagram: {
        title: 'Instagram',
        text: '通过 DM 咨询・预约',
      },
      line: {
        title: '官方 LINE',
        text: '咨询・预约',
      },
    },
  },

  한국어: {
    subTitle: 'CONTACT',
    title: '예약・문의',
    description:
      '예약이나 문의는 Instagram 또는 공식 LINE으로 편하게 연락해 주세요.',
    info: {
      hours: {
        title: '접수 시간',
        lines: ['언제든지 가능', '연중무휴'],
      },
      reply: {
        title: '답변 안내',
        lines: ['가능한 한 빠르게 답변드리겠습니다.'],
      },
      consultation: {
        title: '편하게 문의해 주세요',
        lines: ['원하시는 내용이나 궁금한 점 등', '무엇이든 상담해 주세요.'],
      },
    },
    buttons: {
      instagram: {
        title: 'Instagram',
        text: 'DM으로 상담・예약하기',
      },
      line: {
        title: '공식 LINE',
        text: '상담・예약하기',
      },
    },
  },
};
